type CrossStoreReconciliationExportType = "CSV" | "GENERAL_JOURNAL";
type CrossStoreReconciliationViewMode = "ITEMIZED" | "SUMMARY";

interface ISimplifiedEmployeeCommissionInput {
	locationId: string;
	userId: string;
	position: string;
	frontCommission: number;
	backCommission: number;
}

interface ISalesPerformanceToReconcile {
	_id: string;
	commissions: ISimplifiedEmployeeCommissionInput[];
}

interface IExportCrossStoreReconciliationInput {
	exportOptions: IExportCrossStoreReconciliationExportOptions;
	salesPerformances: ISalesPerformanceToReconcile[];
}

interface IExportCrossStoreReconciliationExportOptions {
	viewFormat: CrossStoreReconciliationViewMode;
	exportType: CrossStoreReconciliationExportType;
	storeBranch: string;
	markAsExported: boolean;
	controlType: string;
}

enum EGroupInclusionType {
	RECOMMENDED_FOR_RECONCILIATION = "Recommended for reconciliation",
	CONSIDER_FURTHER_RECONCILIATION = "Consider further reconciliation",
}

interface IGroupInclusion {
	label: string | EGroupInclusionType;
	value: string | EGroupInclusionType;
}

interface IExportFilter {
	label: string;
	value: string;
}

interface IPositionsExported {
	label: string;
	value: IPositionExportedValue;
}

interface IPositionExportedValue {
	position: string;
	commissionType: "front" | "back";
}

// Enum
export { EGroupInclusionType };

// Types
export type {
	CrossStoreReconciliationExportType,
	CrossStoreReconciliationViewMode,
	IExportCrossStoreReconciliationExportOptions,
	IExportCrossStoreReconciliationInput,
	IExportFilter,
	IGroupInclusion,
	IPositionsExported,
	ISalesPerformanceToReconcile,
	ISimplifiedEmployeeCommissionInput,
	IPositionExportedValue,
};
